var array = Array.prototype;

export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-contour/src/array.js
// module id = ./node_modules/d3-contour/src/array.js
// module chunks = 54